export default __webpack_public_path__ + "23c3f4e560ef4148a137f0b0837f4adf.svg";